import React from 'react';
import {Tooltip} from '@enos/dpl';
import {observer, inject} from 'mobx-react';
import localeText, {getLocale} from '@locale';

import './index.less';

@inject('portalStore', 'sessionStore')
@observer
class Helper extends React.Component {
  render() {
    let helpUrl = '';
    const {fromPortal, sessionStore, fromAdminConsole, portalStore} = this.props;
    if (fromAdminConsole) {
      try {
        helpUrl = JSON.parse(sessionStore.lionConfiguration.adminHelpUrl)[getLocale()];
      } catch (error) {
        console.log('No help URL configured');
      }
    }

    if (fromPortal) {
      helpUrl = portalStore.helpUrl;
    }

    return helpUrl ? (
      <div className='helper sub'>
        <a target='_blank' rel='noopener noreferrer' href={helpUrl}>
          <Tooltip title={localeText('COMMON.COLH_HELP_DOC')} overlayClassName='help-doc'>
            <i className='dpl20_quwstion_circle_o_l header-quwstion' />
          </Tooltip>
        </a>
      </div>
    ) : (
      ''
    );
  }
}

export default Helper;
